import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { requireReleaseFlag } from '@/entities/session/lib/releaseGuard';
import { INQUIRY_TYPES } from '@/pages/inquiry/lib/types';
import { InquiryCompletedPage } from '@/pages/inquiry/ui/InquiryCompletedPage';
import { routeValidateQuerySearch } from '@/shared/lib/route';

const inquiryCompletedSearchSchema = z.object({
  type: z.enum(INQUIRY_TYPES).optional(),
});

export const Route = createFileRoute('/_protected/inquiry/completed')({
  beforeLoad: () => {
    requireReleaseFlag('system_feedback');
  },
  validateSearch: (record) =>
    routeValidateQuerySearch({
      record,
      usePaginationSchema: false,
      customSchema: inquiryCompletedSearchSchema,
    }),
  component: InquiryCompletedPage,
});
